// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckboxV2_root__Sa6rg"};